import { useState } from 'react'
import { Link } from 'react-router-dom'

import { Anchor } from '@mantine/core'
import Box from '../ui/Box'
import Badge from '../ui/Badge'

// UI
import SKU from '../ui/SKU'

// Icons
import { IconArrowUp, IconArrowDown } from '@tabler/icons-react'

// Dayjs
import dayjs from 'dayjs'

export default function ComponentParents({ component }) {
    const [sortBy, setSortBy] = useState('name') // 'name' | 'flow'
    const [sortDir, setSortDir] = useState('asc') // 'asc' | 'desc'

    const toggleSort = (field) => {
        if (sortBy === field) {
            setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'))
        } else {
            setSortBy(field)
            setSortDir(field === 'flow' ? 'desc' : 'asc')
        }
    }

    const parents = component.parents
        .map((cc) => {
            const full_name = cc.component_category.name_fr + ' — ' + cc.name
            const monthlyFlow = Math.round((cc.flow_rate || 0) * 30)

            return {
                quantity: cc.pivot.quantity,
                cc,
                full_name,
                monthlyFlow,
            }
        })
        .sort((a, b) => {
            if (a.cc.is_archived !== b.cc.is_archived) {
                return a.cc.is_archived ? 1 : -1
            }
            const dir = sortDir === 'asc' ? 1 : -1
            if (sortBy === 'flow') {
                return (a.monthlyFlow - b.monthlyFlow) * dir
            }
            return (a.full_name < b.full_name ? -1 : 1) * dir
        })

    return (
        <Box
            className="p-5 bg-white border rounded-sm"
            title="Composants parents"
            subtitle="Utilisent cet élément pour leurs assemblages"
            maxHeight="400px"
        >
            <div className="flex flex-col divide-y divide-gray-100">
                <div className="flex justify-between pb-2">
                    {[
                        { key: 'name', label: 'Nom' },
                        { key: 'flow', label: 'Écoulement' },
                    ].map(({ key, label }) => (
                        <button
                            key={key}
                            onClick={() => toggleSort(key)}
                            className={`inline-flex items-center gap-0.5 px-2 py-1 text-xs rounded ${
                                sortBy === key
                                    ? 'bg-gray-200 text-gray-700 font-medium'
                                    : 'text-gray-400 hover:text-gray-600'
                            }`}
                        >
                            {label}
                            {sortBy === key &&
                                (sortDir === 'asc' ? (
                                    <IconArrowUp size={12} />
                                ) : (
                                    <IconArrowDown size={12} />
                                ))}
                        </button>
                    ))}
                </div>

                {parents.map((child) => {
                    const cc = child.cc

                    return (
                        <div
                            className="flex justify-between items-center w-full py-3"
                            key={cc.id}
                        >
                            <div className="flex items-center gap-2">
                                <SKU component={cc} size="sm" />

                                <Link
                                    className="group"
                                    to={'/components/' + cc.id}
                                >
                                    <Anchor component="span">
                                        {cc.component_category.name_fr} — {cc.name}
                                    </Anchor>
                                </Link>

                                {cc.dispatch_date && (
                                    <span className="text-orange-500 text-sm">
                                        {dayjs(cc.dispatch_date).format('ll')}
                                    </span>
                                )}

                                {cc.is_archived && (
                                    <Badge color="gray" size="xs">
                                        Archivé
                                    </Badge>
                                )}
                            </div>

                            <span className="text-sm font-medium tabular-nums">
                                {child.monthlyFlow > 0 ? (
                                    <>
                                        {child.monthlyFlow}{' '}
                                        <span className="text-gray-400 font-normal">
                                            /mois
                                        </span>
                                    </>
                                ) : (
                                    <span className="text-gray-300">—</span>
                                )}
                            </span>
                        </div>
                    )
                })}
            </div>
        </Box>
    )
}
